var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.configurationForm.show,
            title: "运行配置",
            width: "580px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.configurationForm, "show", $event)
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "show-message": false,
                    "inline-message": false
                  }
                },
                [
                  _c("span", { staticClass: "prompt mr-top" }, [
                    _vm._v("账号配置")
                  ]),
                  _c(
                    "div",
                    { staticClass: "account mr-top" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "登陆账号", prop: "account" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入登陆账号",
                              disabled: !_vm.configurationForm.editor
                            },
                            model: {
                              value: _vm.form.dataInfo.account,
                              callback: function($$v) {
                                _vm.$set(_vm.form.dataInfo, "account", $$v)
                              },
                              expression: "form.dataInfo.account"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: { label: "登陆密码", prop: "password" }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "password",
                              placeholder: "请输入登陆密码",
                              disabled: !_vm.configurationForm.editor
                            },
                            model: {
                              value: _vm.form.dataInfo.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form.dataInfo, "password", $$v)
                              },
                              expression: "form.dataInfo.password"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("span", { staticClass: "prompt mr-top" }, [
                    _vm._v("模板配置")
                  ]),
                  _c("div", { staticClass: "mr-top" }, [
                    _c("span", [_vm._v("第一步：请先下载")]),
                    _c(
                      "a",
                      {
                        staticClass: "setColorBlue",
                        attrs: { src: "" },
                        on: { click: _vm.download }
                      },
                      [_vm._v(" 模板.xlsx")]
                    )
                  ]),
                  _c("div", { staticClass: "mr-top" }, [
                    _vm._v("第二步：按照模版格式填写内容后上传")
                  ]),
                  _c(
                    "div",
                    { staticClass: "mr-top" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload-demo",
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: !_vm.configurationForm.editor,
                            headers: { sessionId: _vm.sessionId },
                            data: {
                              taskConfigUuid: _vm.form.taskConfigUuid
                            },
                            "on-success": _vm.importSuccess,
                            accept: ".xls, .xlsx",
                            drag: "",
                            "file-list": _vm.fileName,
                            limit: 1,
                            "on-remove": _vm.onRemove,
                            action:
                              _vm.request +
                              "/api/external-service/task/excelParse",
                            multiple: ""
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-upload" }),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__text",
                              staticStyle: {
                                color: "#000000",
                                "font-weight": "600"
                              }
                            },
                            [_vm._v("点击或拖拽到此处上传")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              staticStyle: { color: "#666666", opacity: "0.8" }
                            },
                            [_vm._v("支持xls、xlsx格式")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("span", { staticClass: "prompt mr-top" }, [
                    _vm._v("温馨提示：运行查询页面中下载运行结果")
                  ]),
                  _c(
                    "el-form-item",
                    { staticClass: "mr-top" },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { disabled: !_vm.configurationForm.editor },
                          on: {
                            change: function($event) {
                              return _vm.statusChange()
                            }
                          },
                          model: {
                            value: _vm.form.checkList,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "checkList", $$v)
                            },
                            expression: "form.checkList"
                          }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { label: "发送到指定邮箱" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "指定邮箱地址", prop: "email" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "256px" },
                        attrs: {
                          placeholder: "请输入邮箱地址",
                          disabled: !_vm.configurationForm.editor
                        },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.configurationForm.buttonShow,
                      expression: "configurationForm.buttonShow"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.lastStep }
                },
                [_vm._v("上一歩")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.configurationForm.buttonShow &&
                        _vm.configurationForm.editor,
                      expression:
                        "configurationForm.buttonShow && configurationForm.editor"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.createPlan }
                },
                [_vm._v("创建计划")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.configurationForm.buttonShow,
                      expression: "!configurationForm.buttonShow"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.runCreate }
                },
                [_vm._v("运行")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }